// perda.tsx
import React from "react";
import TextFieldRow from "../../../../../components/TextFieldRow";

type Props = {
  responsavelRemocao: string;
  setResponsavelRemocao: (v: string) => void;
  motivoPerda: string;
  setMotivoPerda: (v: string) => void;
};

const PerdaMovement: React.FC<Props> = ({
  responsavelRemocao,
  setResponsavelRemocao,
  motivoPerda,
  setMotivoPerda,
}) => {
  return (
    <div>
      <TextFieldRow
        center={{
          label: "Motivo da Perda",
          value: motivoPerda,
          onChange: setMotivoPerda,
          placeholder: "Ex.: produto vencido, avaria, extravio...",
        }}
      />
    </div>
  );
};

export default PerdaMovement;
